import type { AdvisorOrderView } from '../../../api/advisor';

/** 订单状态标签（客户详情的订单表与「每本书」面板共用） */
export const ORDER_VIEW_META: Record<AdvisorOrderView, { color: string; label: string }> = {
  awaiting_payment: { color: 'gold', label: '待付款' },
  expired: { color: 'default', label: '已过期' },
  paid: { color: 'green', label: '已付款' },
  cancelled: { color: 'default', label: '已取消' },
  refunded: { color: 'red', label: '已退款' },
};
